import Icon from 'react-simple-icons'

function Footer() {
    return (
        <>
        <div className="w-full pb-20">
            <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
                <div className="flex justify-between md:flex-row-reverse flex-col w-full">
                    <div className=" py-4">
                        <div className="flex flex-row gap-8">
                            <div><Icon name='twitter'/></div>
                            <div><Icon name='instagram'/></div>
                            <div><Icon name='behance'/></div>
                        </div>
                    </div>
                    <div className=" py-4 text-xl font-objectsansRegular max-w-2xl">Designed and Made with &#10084; in React.js by MemeGoreng</div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Footer